import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Checkbox from '@material-ui/core/Checkbox';


import InsulationLayer from './InsulationLayer';

import Button from '@material-ui/core/Button';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';


import FormControlLabel from '@material-ui/core/FormControlLabel';


import { getDefaultProduct, getProductsByType, getProdcutsByLanguage, getUIText, getProductsByMarine } from '../../utils/index';

import { openSetting } from '../../modules/app';

import { patchCalculationSection, insulationLayerPositionChange, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, CALCULATION_TOP_LAYERS, CALCULATION_SIDE_LAYERS, CALCULATION_BOTTOM_LAYERS } from '../../modules/calculation';

class Insulation extends Component {

  render() {
    const {
      app,
      project,
      products,
      translations,
      settings,
      user,

      onNoInsulationChange,
      onInsulationLayerChange,
      onInsulationLayerPositionChange,
      openSetting,
   } = this.props;

   const {
     calculations,
     calculationIndex,
     useMarineProducts
   } = project;

   const {
     sectionIndex,
     sections,
     results,
    } = calculations ? calculations[calculationIndex] : {};

   const {
    type,
    cladding,
    insulationLayers,

    noInsulation,
    height,
    outerDiameter,
    supportOfCladding,
    suspensionOfTarget,
    selectedLayers,
    tankBase,

  } = sections ? sections[sectionIndex] : {};

    let layerProducts;

    if(useMarineProducts) {
      layerProducts =  getProductsByType(getProductsByMarine(products.data), type);
    } else {
      layerProducts = getProductsByType(getProdcutsByLanguage(products.data, app.country), type);
    }

    let productsList;
    let layers;

    // Object warnings
    let objectWarnings;
    if(results && results.sectionResults) {
      let sectionResults = results.sectionResults[sectionIndex];
      if(sectionResults && sectionResults.warnings && sectionResults.warnings.object && sectionResults.warnings.object.length) {
        objectWarnings = sectionResults.warnings.object;
      }
    }

    if(layerProducts) {
      productsList = layerProducts.map( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return {...item, id: item.Nid, custom: true};
        } else {
          return {...item, name: item['Product-name']};
//          return {...item, name: item['Product-name']}
        }
      });

      if(user.username != null) {
        productsList.push({
          name: getUIText('CREATE_CUSTOM', app.language, translations),
          id: -3,
          custom: true
        });
      }
      layers = insulationLayers.map( (item, index) => {
        let resultLayer = {};
        let warnings = null;
        let claddingWarning = null;

        if(results && results.sectionResults) {
          let sectionResults = results.sectionResults[sectionIndex];
          let sectionLayers;

          if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
            if(selectedLayers === CALCULATION_TOP_LAYERS) {
              sectionLayers = sectionResults.topLayers.layers;
              sectionResults = results.sectionResults[sectionIndex].topLayers;
            } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
              sectionLayers = sectionResults.sideLayers.layers;
              sectionResults = results.sectionResults[sectionIndex].sideLayers;
            } else {
              sectionLayers = sectionResults.bottomLayers.layers;
              sectionResults = results.sectionResults[sectionIndex].bottomLayers;
            }
            if(sectionLayers) {
              resultLayer =  sectionLayers[(sectionLayers.length - 1) - index];
            }
          } else {
            sectionLayers = sectionResults.layers;
            resultLayer =  sectionLayers[(sectionResults.layers.length - 1) - index];
          }

          if(sectionResults && sectionResults.warnings) {
            warnings = sectionResults.warnings;
          }

          if(sectionResults && sectionResults.warnings && sectionResults.warnings.surface && sectionResults.warnings.surface.length) {
            claddingWarning = sectionResults.warnings.surface;
          }
        }

        return (<InsulationLayer
          cladding={index === 0 ? cladding !== -2 : false}
          key={index}
          index={index}
          products={productsList}
          openSetting={() => openSetting(1)}
          resultLayer={resultLayer}
          claddingWarning={claddingWarning}
          objectWarnings={objectWarnings}
          selectedItem={item.selectedItem}
          firstLayer={ (insulationLayers.length - 1) === index ? true : false}
          lastLayer={ insulationLayers.length === 1 ? index === 0 ? true : false : false}
          selectedThickness={item.selectedThickness}
          disabled={noInsulation}
          warnings={warnings}
          onChange={(value) => {
              onInsulationLayerChange(insulationLayers.map((item, index) => {
                  if(index === value.index) {
                    return { ...item, ...value };
                  }
                  return item;
                })
              );
            }
          }
          onDelete={(value) => {
              onInsulationLayerChange(insulationLayers.filter( (item, index) => {
                return !(item.selectedItem.toString() === value.id.toString() && index.toString() === value.index.toString());
              }));
            }
          }
          />);
      });
    }


    // Insulation end and bottom empty layers
    let insulationEnds = [];
    let emptyLayers = [];
    let insulationPadding = 0;
    let previousThickness = 0;
    let thicknessLines = [];
    let thicknessTexts = [];
    if(type === CALCULATION_TYPE_PIPE || type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      thicknessLines.push(<div key={0} className="layer-thickness" style={{top: insulationLayers.length * 40, height: 50 + 'px', left: insulationLayers.length * 10 + 'px'}} />);
      if(type !== CALCULATION_TYPE_RECTANGULAR_DUCT) {
        thicknessTexts.push(<div key={0} className="thickness-text" style={{bottom: insulationLayers.length * 40}}>{outerDiameter} mm</div>);
        previousThickness = outerDiameter;
      } else {
        thicknessTexts.push(<div key={0} className="thickness-text" style={{bottom: insulationLayers.length * 40}}>{height} mm</div>);
        previousThickness = height;
      }
    }

    for (var i = 0; i < insulationLayers.length; i++) {
      if(cladding !== -2 && i === insulationLayers.length - 1) {
        emptyLayers.push(<div key={i} className="empty-layer cladding">{type === CALCULATION_TYPE_RECTANGULAR_DUCT ? <div className="rect cladding" /> : null}</div>);

        if(type === CALCULATION_TYPE_PIPE || type === CALCULATION_TYPE_CIRCULAR_DUCT) {
          insulationEnds.unshift(<div key={i} className={'insulation-circle cladding layer-' + (i + 1)} style={{top: ((insulationLayers.length - (i + 1)) * 40) + 'px'}} />);
        } else {
          insulationEnds.unshift(<div key={i} className={'insulation-rect cladding layer-' + (i + 1)} style={{top: ((insulationLayers.length - (i + 1)) * 40 + 2) + 'px'}} />);
        }
      } else {
        emptyLayers.push(<div key={i} className="empty-layer" >{type === CALCULATION_TYPE_RECTANGULAR_DUCT ? <div className="rect" /> : null}</div>);

        if(type === CALCULATION_TYPE_PIPE || type === CALCULATION_TYPE_CIRCULAR_DUCT) {
          insulationEnds.unshift(<div key={i} className={'insulation-circle layer-' + (i + 1)} style={{top: ((insulationLayers.length - (i + 1)) * 40) + 'px'}} />);
        } else {
          insulationEnds.unshift(<div key={i} className={'insulation-rect layer-' + (i + 1)} style={{top: ((insulationLayers.length - (i + 1)) * 40 + 2) + 'px'}} />);
        }
      }

      if(type === CALCULATION_TYPE_PIPE || type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
        insulationPadding = 5 * (i + 1);
        previousThickness = Number(previousThickness) + Number((insulationLayers[insulationLayers.length - (i + 1)].selectedThickness * 2));
        thicknessLines.push(<div key={(i + 1)} className="layer-thickness" style={{top: (insulationLayers.length - (i + 1)) * 40, height: ((i + 1) * 80 + 50) + 'px', left: (insulationLayers.length - (i + 1)) * 10 + 'px'}}/>);
        thicknessTexts.push(<div key={(i + 1)} className="thickness-text" style={{bottom: (insulationLayers.length - (i + 1)) * 40}} >{previousThickness} mm</div>);
      } else {
        previousThickness = Number(previousThickness) + Number((insulationLayers[insulationLayers.length - (i + 1)].selectedThickness));
        thicknessLines.push(<div key={(i + 1)} className="layer-thickness" style={{top: (insulationLayers.length - (i + 1)) * 40, height: ((i + 1) * 40) + 'px', left: (insulationLayers.length - (i + 1)) * 10 + 'px'}}/>);
        thicknessTexts.push(<div key={(i + 1)} className="thickness-text" style={{bottom: (i + 1) * 40}} >{previousThickness} mm</div>);
      }
    }

    // Element object
    let elementItem;
    let elementClassName;
    if(type === CALCULATION_TYPE_PIPE) {
      elementClassName = 'pipe';
    } else if (type === CALCULATION_TYPE_CIRCULAR_DUCT) {
      elementClassName = 'circular-duct';
    } else if (type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      elementClassName = 'rectancular-duct';
    }

    if(elementClassName) {
      elementItem = (<div className="element-item" style={{paddingRight: insulationLayers.length * 12 + 60 + 'px'}}>
        <div className={elementClassName}>
          <div className="end" /></div>
      </div>);
    } else {
      emptyLayers = null;
      elementItem = <div className="basic-element"><div className="end"/></div>;
    }

    // Default product when new layer is created
    let addNewLayer;
    if(insulationLayers && insulationLayers.length > 0) {
      addNewLayer = insulationLayers[0];
    } else {
      addNewLayer = getDefaultProduct(products, settings, app.country, type);
    }

    let insulationLayerButtons;
    if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      /*
      insulationLayerButtons = (
        <div style={{display: 'inline-block'}}>
          <ButtonWithIcon icon={selectedLayers === CALCULATION_TOP_LAYERS ? "fa fa-circle" : "fa fa-circle-o"} onClick={(value) => onInsulationLayerPositionChange(CALCULATION_TOP_LAYERS)} label={getUIText("TANK-EDIT_TOP", app.language, translations)} />
          <ButtonWithIcon icon={selectedLayers === CALCULATION_SIDE_LAYERS ? "fa fa-circle" : "fa fa-circle-o"} onClick={(value) => onInsulationLayerPositionChange(CALCULATION_SIDE_LAYERS)} label={getUIText("TANK-EDIT_SIDES", app.language, translations)} />
          <ButtonWithIcon icon={selectedLayers === CALCULATION_BOTTOM_LAYERS ? "fa fa-circle" : "fa fa-circle-o"} onClick={(value) => onInsulationLayerPositionChange(CALCULATION_BOTTOM_LAYERS)} label={getUIText("TANK-EDIT_BOTTOM", app.language, translations)} />
        </div>
      )
      */

      insulationLayerButtons = (
        <RadioGroup
          value={selectedLayers}
          onChange={ (event, value) => onInsulationLayerPositionChange(value) }
          row
        >
          <FormControlLabel value={CALCULATION_TOP_LAYERS} control={<Radio />} label={getUIText('TANK-EDIT_TOP', app.language, translations)} className="mb-0" />
          <FormControlLabel value={CALCULATION_SIDE_LAYERS} control={<Radio />} label={getUIText('TANK-EDIT_SIDES', app.language, translations)} className="mb-0" />
          <FormControlLabel value={CALCULATION_BOTTOM_LAYERS} control={<Radio />} label={getUIText('TANK-EDIT_BOTTOM', app.language, translations)} className="mb-0" />
        </RadioGroup>
      );
    }
    const tankStandingRule = (
      (tankBase !== 'concrete' && tankBase !== 'ground') ||
      ((tankBase === 'concrete' || tankBase === 'ground') && selectedLayers !== CALCULATION_BOTTOM_LAYERS)
    );

    let insulation = (
      <div className="insulation-holder" style={{marginLeft: insulationPadding + 'px'}}>
        <div>
          {insulationLayerButtons}
        </div>
        {
          /* <ButtonWithIcon icon="fa fa-plus-circle" disabled={insulationLayers.length >= 5 ? true : false} onClick={(event) => onInsulationLayerChange([addNewLayer, ...insulationLayers])} label={getUIText("INSULATION-ADD_INSULATION_LAYER", app.language, translations)} />*/
          tankStandingRule &&
            <Button color="primary" className="mb-2" disabled={insulationLayers.length >= 5 ? true : false} onClick={(event) => onInsulationLayerChange([addNewLayer, ...insulationLayers])} >
              <i className="fa fa-plus mr-2"/>{getUIText('INSULATION-ADD_INSULATION_LAYER', app.language, translations)}
            </Button>
        }
        <div className="insulation" style={{paddingRight: insulationLayers.length * 12 + 60 + 'px'}} >
          <div className="end-layers">
            <div className="layers">
              {insulationEnds}
            </div>
          </div>
          <div className="insulation-layers">
            {layers}
          </div>
          { emptyLayers ?
            <div className="empty-layers">
            {emptyLayers}
          </div> : null
          }
          {elementItem}

          { suspensionOfTarget ?
            <div className="suspension-element" style={{right: ( (layers.length - 1) * 12 + 90) + 'px'}}>
              { emptyLayers ? <div className="element-section-top" style={{marginTop: '-6px'}}/> : null}
              { emptyLayers ? <div className="element-section" style={{marginTop: (layers.length * 40 + 16) + 'px'}} /> : null}
            </div> : null
          }

          { supportOfCladding ?
            <div className="support-element" style={{right: ( (layers.length - 1) * 12 + 110 ) + 'px'}}>
              { emptyLayers ? <div className="element-section-top" style={{marginTop: '-2px'}}/> : null}
              { emptyLayers ? <div className="element-section" style={{marginTop: (layers.length * 40 ) + 'px'}} /> : null}
              { emptyLayers ? <div className="element-section-bottom" style={{marginTop: (layers.length * 40) + 'px'}} /> : null}
            </div> : null
          }

          <div className="thickness-container" style={{right: ((layers.length - 1) * 12) + 7 + 'px'}}>
            {thicknessLines}
          </div>
          <div className="thickness-texts">
            {thicknessTexts}
          </div>
        </div>
        <FormControlLabel
            control={
              <Checkbox
                checked={noInsulation}
                onChange={(event, value) => onNoInsulationChange(value)}
                disabled={!tankStandingRule}
              />
            }
            label={getUIText('GENERAL-NO_INSULATION', app.language, translations)}
          />
      </div>
    );

    return (
      <div>
        {insulation}
      </div>
    );
  }
}

Insulation.propTypes = {
    app: PropTypes.object,
    project: PropTypes.object,
    products: PropTypes.object,
    translations: PropTypes.object,
    settings: PropTypes.object,
    user: PropTypes.object,
  onNoInsulationChange: PropTypes.any,
  onInsulationLayerChange: PropTypes.any,
  onInsulationLayerPositionChange: PropTypes.any,
  openSetting: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        app: state.app,
        project: state.project,
        products: state.products,
        translations: state.translations,
        settings: state.settings,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onNoInsulationChange: noInsulation => dispatch(patchCalculationSection({ noInsulation })),
        onInsulationLayerChange: insulationLayers => {
          dispatch(patchCalculationSection({ insulationLayers }));
        },
        onInsulationLayerPositionChange: selectedLayers => dispatch(insulationLayerPositionChange({ selectedLayers })),

        openSetting: layout => dispatch(openSetting(layout)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Insulation);
